// extracted by mini-css-extract-plugin
export default {"header":"IL8uY"};